import { Component, OnInit } from '@angular/core';
import { first } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { QuantiteTotalByWorkflowDTO } from '../../core/model/quantite_by_workflow/quantite-total-by-workflow-dto';
import { DashboardPersonnelService } from '../../core/service/dashboard-personnel.service';
import { QuantiteDossierPortefeuilleDTO } from '../../core/model/quantite-dossier-portefeuille-dto';
import { DashboardService } from '../../core/service/dashboard.service';
import { KeycloakService } from 'src/app/core/services/auth/keycloak.service';
import { TacheByUserComponent } from '../../modal/tache-by-user/tache-by-user.component';
import { UserService } from 'src/app/shared/directives/user.service';

@Component({
  selector: "app-performance",
  templateUrl: "./performance.component.html",
  styleUrls: ["./performance.component.scss"],
})
export class PerformanceComponent implements OnInit {
  username: String;
  myUsername: String;

  MyPermissions: string[];
  private userPermission = {
    permissions: [],
  };

  corporatePortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  particulierPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  professionnelPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();
  productProgramPortefeuille: QuantiteDossierPortefeuilleDTO =
    new QuantiteDossierPortefeuilleDTO();

  constructor(
    private modalService: NgbModal,
    private _dashboardPersonnelService: DashboardPersonnelService,
    private _dashboardService: DashboardService,
    private _keycloakService: KeycloakService,
        private userService: UserService,
  ) {
    this.myUsername = _keycloakService.getUsername();
    this.username = this.myUsername;
    localStorage.setItem("aRegularier", "");

       this.MyPermissions = _keycloakService.getAccessPermissions();
       this.userPermission.permissions = this.MyPermissions;
       this.userService.setUser(this.userPermission);
  }

  ngOnInit() {
    this.quantiteDossierPortefeuilleCorporate(this.username);
    this.quantiteDossierPortefeuilleParticulier(this.username);
    this.quantiteDossierPortefeuilleProfessionnel(this.username);
    this.quantiteDossierPortefeuilleProductProgram(this.username);
  }

  quantiteDossierPortefeuilleCorporate(username) {
    this._dashboardPersonnelService
      .quantiteDossierPortefeuilleByUsername("CORPORATE", username)
      .pipe(first())
      .subscribe(
        (data) => {
          this.corporatePortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleParticulier(username) {
    this._dashboardPersonnelService
      .quantiteDossierPortefeuilleByUsername("PARTICULIER", username)
      .pipe(first())
      .subscribe(
        (data) => {
          this.particulierPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleProfessionnel(username) {
    this._dashboardPersonnelService
      .quantiteDossierPortefeuilleByUsername("PROFESSIONNEL", username)
      .pipe(first())
      .subscribe(
        (data) => {
          this.professionnelPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  quantiteDossierPortefeuilleProductProgram(username) {
    this._dashboardPersonnelService
      .quantiteDossierPortefeuilleByUsername("PRODUCT_PROGRAM", username)
      .pipe(first())
      .subscribe(
        (data) => {
          this.productProgramPortefeuille = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }

  tacheEncoursByUser(workflow) {
    /*
   const modalRef = this.modalService.open(TacheByUserComponent,{
     size: 'lg', backdrop: 'static', centered:true
   });
   modalRef.componentInstance.workflow = workflow;
   modalRef.componentInstance.username = this.myUsername;

   modalRef.result.then((data) => {
     
     }, (reason) => {
       
     });
     */
  }
}
